import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import { SCUIButton } from '../../../../../../atomic/atoms';
import { RuleTabGrid, RuleTabModal } from './components';
import { RT } from './ruleTab.classes';

export const RuleTab: FC<any> = () => {
    const [isRuleModalOpen, setIsRuleModalOpen] = useState<boolean>(false);
    const [selectedRule, setSelectedRule] = useState<any>();

    const { t } = useTranslation();

    return (
        <>
            <Box className={RT.root} sx={{ padding: '16px' }}>
                <SCUIButton
                    className={RT.createButton}
                    showStartIcon
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    text={t('ruleManagement.createNewRuleV2')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={() => {
                        setIsRuleModalOpen(true);
                    }}
                />
                <Box className={RT.gridSection} sx={{ paddingTop: '16px' }}>
                    <RuleTabGrid setSelectedRule={setSelectedRule} setIsRuleModalOpen={setIsRuleModalOpen} />
                </Box>
            </Box>
            <div className={RT.modalSection}>
                <RuleTabModal
                    setSelectedRule={setSelectedRule}
                    selectedRule={selectedRule}
                    isModalOpen={isRuleModalOpen}
                    setIsModalOpen={setIsRuleModalOpen}
                />
            </div>
        </>
    );
};
